import { render, staticRenderFns } from "./teamStepComponent.vue?vue&type=template&id=4fda8e83&"
import script from "./teamStepComponent.vue?vue&type=script&lang=js&"
export * from "./teamStepComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports